import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Star, Zap, Shield, Download, BarChart3, Headphones } from 'lucide-react';
import styles from '../../styles/Pricing/Pricing.module.css';

const Pricing = () => {
  const features = [
    {
      icon: <Download size={20} />,
      title: "Data Access",
      items: [
        "Unlimited stocks data entry",
        "Export tables to CSV",
        "Unlimited Sectors Creation",
        "Real-time market data"
      ]
    },
    {
      icon: <BarChart3 size={20} />,
      title: "Premium Analytics",
      items: [
        "Full analytics dashboard",
        "Advanced charts & graphs",
        "Portfolio performance tracking",
        "Custom reporting tools"
      ]
    },
    {
      icon: <Headphones size={20} />,
      title: "Premium Support",
      items: [
        "Priority customer support",
        "On-demand modifications",
        "Regular platform updates",
        "Dedicated account manager"
      ]
    }
  ];

  return (
    <section className={styles.pricingSection}>
      <div className={styles.container}>
        <div className={styles.headerSection}>
          <div className={styles.badge}>
            <Star size={16} />
            <span>Early Access</span>
          </div>
          <h2 className={styles.title}>Premium Access</h2>
          <p className={styles.subtitle}>
            Unlock powerful financial tools with our exclusive early access offer
          </p>
        </div>
        
        <div className={styles.pricingCard}>
          <div className={styles.ribbon}>
            <Zap size={14} />
            <span>SPECIAL OFFER</span>
          </div>
          
          <div className={styles.pricingHeader}>
            <div className={styles.planInfo}>
              <h3 className={styles.planName}>Pro Trader</h3>
              <p className={styles.planDescription}>
                Complete access to all premium features
              </p>
            </div>
            
            <div className={styles.priceContainer}>
              <div className={styles.priceWrapper}>
                <span className={styles.originalPrice}>₹599</span>
                <span className={styles.currentPrice}>₹0</span>
                <span className={styles.period}>/year</span>
              </div>
              <div className={styles.discount}>
                <Shield size={16} />
                <span>100% OFF for Early Users</span>
              </div>
            </div>
          </div>
          
          <div className={styles.features}>
            {features.map((feature, index) => (
              <div key={index} className={styles.featureGroup}>
                <div className={styles.featureHeader}>
                  {feature.icon}
                  <h4>{feature.title}</h4>
                </div>
                <ul>
                  {feature.items.map((item, itemIndex) => (
                    <li key={itemIndex}>
                      <Check size={16} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          
          <div className={styles.ctaSection}>
            <Link to="/login" className={styles.ctaButton}>
              <Zap size={18} />
              <span>Claim Free Access</span>
            </Link>
            <p className={styles.limitedOffer}>
              Limited time offer for early adopters
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;